import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TermsOfService from './TermsOfService';
import { useAuth } from '../contexts/AuthContext';

const PublicTermsOfService: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {!currentUser && (
        <Alert 
          severity="info" 
          sx={{ mb: 3 }}
          action={
            <Button 
              color="inherit" 
              size="small" 
              onClick={() => navigate('/login')}
            >
              Sign In
            </Button>
          }
        >
          Sign in to access all features of Amsler Grid Daily
        </Alert>
      )}
      <TermsOfService />
    </Container>
  );
};

export default PublicTermsOfService; 